import { nanoid } from 'nanoid';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { PetitionGuidesDataQuery, PetitionGuidesDataQueryVariables } from './api.graphql';
import { PetitionGuidesData } from './api.graphql';

export type PetitionGuidesPageData = {
	article: NonNullable<PetitionGuidesDataQuery['article']>;
	articles: NonNullable<PetitionGuidesDataQuery['articles']>;
	coreArticles: NonNullable<PetitionGuidesDataQuery['coreArticles']>;
	aiSapId: string;
};

export async function getPetitionGuidesPageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<PetitionGuidesPageData> {
	// `coreArticles` and `articles` are fetched with `failSilently: true` — a genuine backend
	// failure on either resolves to an empty list rather than throwing, so a broken nav list
	// can't take down this page over non-critical navigation content. `article` has no such
	// fallback, so it's the only field here that can still throw and take the whole query down
	// with it, which is the intended critical/tolerated split.
	const { data } = await fetch<PetitionGuidesDataQuery, PetitionGuidesDataQueryVariables>({
		query: PetitionGuidesData,
		variables: {
			slug,
		},
		rejectOnError: true,
	});

	if (!data.article) {
		throw new NotFoundError();
	}

	return {
		article: data.article,
		coreArticles: data.coreArticles,
		articles: data.articles,
		aiSapId: nanoid(),
	};
}
